/* Change this file to get your personal Portfolio */

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Nityam",
  title: "Hi all, I'm Nityam",
  subTitle: emoji(
    "A passionate Software Developer 🚀 having an experience of building Web and Mobile applications with JavaScript / Reactjs / Nodejs / Vue js and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1sfN9TBGnDseIxkmELfsdZmK1dMngwAfA/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  gmail: "nityamgosain@gmail.com",
  // Instagram and Twitter are also supported in the links!
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Bharati Vidyapeeth's College of Engineering",
      logo: require("./assets/images/bvp.png"),
      subHeader: "Master in Computer Science",
      duration: "July 2016 - April 2019",
    },
    {
      schoolName: "Indraprastha University",
      logo: require("./assets/images/ip.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "July 2013 - April 2016",
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Programming",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Snapdeal",
      date: "Jan 2021 – Present",
      companylogo: require("./assets/images/snapdeal.png"),
      desc:
        "Worked on Buyer Platform.",
    },
    {
      role: "Front-End Developer",
      company: "Grappus",
      companylogo: require("./assets/images/grappus.png"),
      date: "Jan 2019 – Dec 2020",
      desc:
        "Worked on Various Project"
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "",
  projects: [
    {
      image: require("./assets/images/star-health.png"),
      projectName: "StarHealth",
      projectDesc: "Revamp of star health",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://star-health.grappus.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/love-yours.jpeg"),
      projectName: "Love From Yours",
      projectDesc: "The Company that provide beauty products in singapore",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://dev-web.lovefromyours.com"
        }
      ]
    },
    {
      image: require("./assets/images/ateam.png"),
      projectName: "Ateam",
      projectDesc: "Website for dating app",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://ateam.co/"
        }
      ]
    },
    {
      image: require("./assets/images/outboxy.png"),
      projectName: "Outboxy",
      projectDesc: "Design packaging boxes online and order them",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://beta.outboxy.com/"
        }
      ]
    }
    ,
    {
      image: require("./assets/images/deloitte.png"),
      projectName: "Deloitte digital readniess too",
      projectDesc: "A tool that deloitte wanted to develop for their client WNS to check digital awarness of their employee.",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://difu.wns.com/"
        }
      ]
    },
    ,
    {
      image: require("./assets/images/famhealth.jpeg"),
      projectName: "Famhealth",
      projectDesc: "Revamp of famhealth",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://famhealth.in/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc


// Blogs Section

const blogSection = {
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me"),
  email_address: "nityamgosain@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
